export default "__VITE_ASSET__BTnzwRos__"